<template>
  <div>
    <cover v-model="isCustomPopup"/>
    <div :class="[isTimeOut ? 'custom-popup time-out-popup dynamic-content custom-portal-popup' : 'custom-popup dynamic-content custom-portal-popup']" v-if="isCustomPopup" :style="{'justify-content' : 'space-between'}">
      <div v-if="!isTimeOut" class="close-popup" @click="closePopup()" tabindex="0" @keydown.enter.space.stop="closePopup()" style="outline: none; cursor: pointer;">
        <svg-icon :name="'closed-popup'"></svg-icon>
      </div>
      <div class="greet" v-text="title"></div>
      <p class="content" v-if="content" v-html="content"></p>
      <p class="content" v-if="startLineOfLoanContent">
        <span v-html="startLineOfLoanContent"></span>
        <a v-if="isShowLoansPopup" href="mailto:programs@missionassetfund.org" @click="closePopup()" class="notranslate">programs@missionassetfund.org</a>
        <span v-html="endLineOfLoanContent"></span>
      </p>

      <div v-if="isShowLoansPopup" :class="[isMobile ? 'custom-btns' : 'horizontal-btns']">
        <maf-button class="button" name="OK" :width="loanPopupWidth" :minWidth="loanPopupMinWidth" :fontSize="btnFont" @actionFunc="closePopup()"/>
        <maf-button class="button" data-a11y-first="true" :name="btnName" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" :width="loanPopupWidth" :minWidth="loanPopupMinWidth" :fontSize="btnFont" @actionFunc="switchToActivePrograms()"/>
      </div>

      <div v-else-if="isTimeOut" class="custom-btns">
        <maf-button class="button" data-a11y-first="true" name="Return to login" :width="btnWidth" :fontSize="btnFont" @actionFunc="returnToLogin()"/>
      </div>

      <div class="custom-btns" v-else>
        <maf-button v-if="step === 0" data-a11y-first="true" :name="'Start Application'" @actionFunc="setStep()"/>

        <div v-if="step === 1">
          <maf-button class="button" v-if="isDACAGrantAvailable" data-a11y-first="true" :name="dacaGrantBtnText" :width="btnWidth" :fontSize="btnFont" @actionFunc="setStep('DACAPreAppGrant')"/>
          <maf-button class="button" v-if="isDACALoanAvailable" :name="dacaLoanBtnText" :width="btnWidth" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="setStep('DACALoan')"/>
          <maf-button class="button ifrp-btn" v-if="isIFRPAvailable" :width="btnWidth" :fontSize="btnFont" :name="ifrpBtnText" @actionFunc="setStep('IFRP')"/>
          <maf-button class="button" v-if="isIFRPLoanAvailable" :width="btnWidth" :fontSize="btnFont" :name="ifrpLoanBtnText" @actionFunc="setStep('IFRP-Loan')"/>
          <maf-button class="button" v-if="isMIJAGrantAvailable" :name="mijaGrantBtnText" :width="btnWidth" :fontSize="btnFont" @actionFunc="setStep('Immigration-Grant-OCEIA')"/>
        </div>

        <maf-button v-if="step === 2" data-a11y-first="true" :name="'Yes, that\'s me'" @actionFunc="insertApplication()"/>
        <maf-button v-if="step === 2" :name="'No, that\'s not correct'" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="setStep()"/>

        <maf-button v-if="step === 3" data-a11y-first="true" :name="'Create a new MAF account'" :width="300" @actionFunc="createMafAccount()"/>
        <div v-if="step === 3" class="help" @click="help()">I need help</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { startScholarshipApplicationRemoting, startClientApplicationBySourceRemoting, getViewLoansRemoting, openSurveyByLanguage } from '../../api'

export default {
  name: 'CustomPopup',
  props: {
  },
  data() {
    return {
    };
  },
  watch: {
    isCustomPopup: function(newVal) {
      if (newVal === true) {
        this.$nextTick(function() {
          // 利用 main.js 里的全局 $A11yFocus 拦截器，将焦点死死抓在这个弹窗内打了 [data-a11y-first] 标的核心按钮上
          if (this.$A11yFocus) {
            this.$A11yFocus.lock('.custom-portal-popup', '[data-a11y-first="true"]');
          }
        });
      } else {
        if (this.$A11yFocus) {
          this.$A11yFocus.unlock();
        }
      }
    },

    step: function(newStep) {
      if (this.isCustomPopup) {
        this.$nextTick(function() {
          if (this.$A11yFocus) {
            this.$A11yFocus.lock('.custom-portal-popup', '[data-a11y-first="true"]');
          }
        });
      }
    }
  },
  beforeDestroy() {
    if (this.$A11yFocus && typeof this.$A11yFocus.unlock === 'function') {
      this.$A11yFocus.unlock();
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isDACAGrantAvailable: state => state.contactInfo.isDACAGrantAvailable,
      dacaGrantBtnText: state => state.dacaGrantBtnText,
      isDACALoanAvailable: state => state.contactInfo.isDACALoanAvailable,
      dacaLoanBtnText: state => state.dacaLoanBtnText,
      isIFRPAvailable: state => state.contactInfo.isIFRPAvailable,
      ifrpBtnText: state => state.ifrpBtnText,
      isIFRPLoanAvailable: state => state.contactInfo.isIFRPLoanAvailable,
      ifrpLoanBtnText: state => state.ifrpLoanBtnText,
      isMIJAGrantAvailable: state => state.contactInfo.isMIJAGrantAvailable,
      mijaGrantBtnText: state => state.mijaGrantBtnText,
      contactSources: state => state.contactInfo.contactSources,
      isMobile: state => state.isMobile,
      step: state => state.popupStep,
      checkedSource: state => state.checkedBtnSource,
      isShowLoansPopup: state => state.showLoansPopup.isShow,
      loanStatus: state => state.showLoansPopup.loanStatus,
      isCustomPopup: state => state.isCustomPopup,
      retProgramEligibilityUrls: state => state.retProgramEligibilityUrls,
      isTimeOut: state => state.timeOut,
    }),
    btnWidth() {
      if (this.isMobile) {
        return 325;
      }
      return 390;
    },
    loanPopupWidth() {
      if (this.isMobile) {
        return 325;
      }
      return 'unset';
    },
    loanPopupMinWidth() {
      if (this.isMobile) {
        return 325;
      }
      return 'unset';
    },
    btnFont() {
      if (this.isMobile) {
        return 13;
      }
      return 16;
    },
    title() {
      if (this.isTimeOut) {
        return 'Your NCA Dashboard session has timed out. Please log in again to continue. If you are in the process of filling out an application, changes not previously saved will unfortunately be lost.';
      }

      if (this.loanStatus) {
        if (this.isLoanStatusChargeOff()) {
          return 'It seems that you currently have an outstanding balance with MAF from a previous charged off loan.';
        }
        return 'It seems that you already have an active loan with us.';
      }

      if (this.step === 2) {
        return 'Please verify your identity before proceeding with your application:';
      }

      if (this.step === 3) {
        return 'Sorry, we can\'t proceed.'
      }

      return 'Welcome to the MAF Portal!';
    },
    content() {
      if (this.isTimeOut) {
        return '';
      }

      if (this.loanStatus) {
        return '';
      }
      if (this.step === 2) {
        return '<p>My name is: <span class="notranslate">' + this.userInfo.firstName + ' ' + this.userInfo.lastName + '</span</p><p>My year of birth: ' + this.userInfo.yearOfBirth + '</p>';
      }
      if (this.step === 3) {
        return 'We require that each applicant has a unique MAF account and email address. If you would like to start a new application with a different email, start by creating a new MAF account.'
      }

      return 'On this site, you can track and check the status of your application. To get started, click on a button below to start your application.';
    },
    startLineOfLoanContent() {
      if (this.loanStatus) {
        if (this.isLoanStatusChargeOff()) {
          return `Unfortunately, we are unable to offer you a new loan until this balance has been paid off in full.</br>
      If you wish to pay off that balance, please reach out to us at `;
        }
        return `Unfortunately, we are unable to offer you a new loan until your active loan is paid in full.</br>
      Please reach out to us at `;
      }
    },
    endLineOfLoanContent() {
      if (this.loanStatus) {
        if (this.isLoanStatusChargeOff()) {
          return ` and we’ll be able to provide next steps for you.`;
        }
        return ` if you have any questions or would like assistance managing this loan.`;
      }
    },
    btnName () {
      if (this.isLoanStatusChargeOff()) {
        return 'See my balance';
      } else {
        return 'See active loan';
      }
    },
  },
  methods: {
    help() {
      window.open('https://maf.my.site.com/help', '_blank');
    },
    returnToLogin() {
      let email = this.userInfo.email.replace(/\+/g, '%2B');
      window.open('/lendingcircles/NCAGetStartPage?email=' + email + '&startUrl=' + window.location.href, '_self');
    },
    closePopup() {
      if (this.loanStatus) {
        this.$trackEvent('Ineligible client attempt', this.userInfo);
      }
      this.$store.commit('IS_POPUP_STEP_CHANGED', 0);
      this.$store.commit('IS_CUSTOM_POPUP_CHANGED', false);
      var loanErrorPopup = {};
      loanErrorPopup.isShow = false;
      loanErrorPopup.loanStatus = '';
      this.$store.commit('SHOW_LOANS_POPUP', loanErrorPopup);
      this.$store.commit('TIME_OUT', false);
    },
    switchToActivePrograms () {
      this.closePopup();
      this.$store.commit('CURRENT_TAB_CHANGED', {
        label: 'Active Programs'
      });
      this.$router.push({name: 'Active Programs'})
    },
    async setStep(btnSource) {
      let loanErrorPopup = { isShow: false };
      if (btnSource === 'DACALoan') {
        loanErrorPopup = await getViewLoansRemoting(this.userInfo.userId);
        console.log(loanErrorPopup)
      }

      if (loanErrorPopup.isShow) {
        this.$store.commit('SHOW_LOANS_POPUP', loanErrorPopup);
      } else {
        if (btnSource) {
          this.$store.commit('IS_BUTTON_SOURCE_CHANGED', btnSource);
        }
        this.$store.commit('IS_POPUP_STEP_CHANGED', this.step + 1);
      }
    },
    createMafAccount() {
      window.open('/lendingcircles/NCAGetStartPage', '_blank');
    },
    async insertApplication() {
      this.$store.state.isLoading = true;
      let url;
      let result;

      if (!this.checkedSource) {
        openSurveyByLanguage(this.retProgramEligibilityUrls, this.userInfo.contactId);
        return;
      }
      // SA
      if (this.checkedSource === 'DACAPreAppGrant') {
        url = 'SADACA21Application';
        result = await startScholarshipApplicationRemoting(this.checkedSource, this.userInfo.userId);
      } else if (this.checkedSource === 'IFRP') {
        url = 'IFRPApplicationOne';
        result = await startScholarshipApplicationRemoting('IFRP-2021', this.userInfo.userId);
      } else if (this.checkedSource === 'Immigration-Grant-OCEIA') {
        url = 'NCAGrantApplication';
        result = await startScholarshipApplicationRemoting('Immigration-Grant-OCEIA', this.userInfo.userId);
      }

      // CA
      if (this.checkedSource === 'DACALoan') {
        url = 'NCALoanApplication';
        result = await startClientApplicationBySourceRemoting(this.checkedSource, this.userInfo.userId);
      }

      if (this.checkedSource === 'IFRP-Loan') {
        url = 'NCALoanApplication';
        result = await startClientApplicationBySourceRemoting(this.checkedSource, this.userInfo.userId);
      }

      if (result.indexOf('Success') !== -1) {
        window.open('/lendingcircles/' + url + '?id=' + result.substr(7), '_self');
      } else {
        this.$store.state.isLoading = false;
        console.error(result);
      }
    },
    isLoanStatusChargeOff() {
      return this.loanStatus === 'Charge Off';
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/main.scss';
.custom-popup {
  @include flex-col;
  justify-content: space-between;
  max-width: 600px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  padding: 50px;
  background: #fefefe;
  border-radius: 7px;
  text-align: center;
  z-index: 999999;
  min-height: 360px;

  @media screen and (max-width: $max-width-phone) {
    padding: 35px 15px;
    min-width: 350px;
  }

  .close-popup {
    position: absolute;
    top: 25px;
    right: 25px;

    @media screen and (max-width: $max-width-phone) {
      top: 10px;
      right: 10px;
    }
  }

  .greet {
    font-family: ncaDashboardFont;
    font-size: $font-size-larger;
    color: #834bc4;
    letter-spacing: 0.21px;
    text-align: center;
  }

  .content {
    font-family: sans-serif;
    font-size: $font-size-base;
    color: #393C40;
    letter-spacing: 0;
    text-align: center;
    line-height: 23px;
  }

  .custom-btns {
    @include flex-col;
    justify-content: space-between;
    min-height: 100px;
    align-items: center;

    .button {
      margin-bottom: 10px;
    }

    .help {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }

  .horizontal-btns {
    @include flex-row;
    justify-content: center;
    button:nth-child(1) {
      min-width: 150px;
    }
    button:nth-child(2) {
      width: unset;
      min-width: 150px;
      margin-left: 5px;
      padding: 9px 10px;
    }
  }
}

.time-out-popup {
  max-width: 480px;
  padding: 30px;
  justify-content: normal;
  min-height: auto;

  .custom-btns {
    margin-top: 20px;
    min-height: unset;
    .button {
      width: auto !important;
      margin-bottom: 0px;
      background: linear-gradient(134deg, #3023AE 0%, #C86DD7 100%) !important;
      padding: 9px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/CustomPopup.vue